/**
 * U0 · the vocabulary the components render from — served by the backend, never copied here.
 *
 * `useVocabulary()` resolves once per page load. Until it resolves, components render with
 * the empty vocabulary: no families (rows uncoloured), no toolbox entries, default limits —
 * and nothing invented. `factsOf(step, limit)` is the one place a step's summary facts are
 * chosen: the pairs the owner did not mark as identity, up to the served limit.
 */
import { useEffect, useState } from "react";

let cache = null;
let pending = null;
const EMPTY = { step_types: [], families: {}, sign_meanings: [], sign_labels: [], limits: {} };

export function loadVocabulary(fetcher) {
  if (cache) return Promise.resolve(cache);
  // A failed load answers EMPTY once and is forgotten, so the next mount tries again: a
  // vocabulary that failed at startup must not stay empty for the life of the tab.
  if (!pending) pending = fetcher().then((v) => { cache = v; return v; }).catch(() => { pending = null; return EMPTY; });
  return pending;
}

export function useVocabulary(fetcher) {
  const [vocab, setVocab] = useState(cache || EMPTY);
  useEffect(() => { let alive = true; loadVocabulary(fetcher).then((v) => alive && setVocab(v)); return () => { alive = false; }; }, [fetcher]);
  return vocab;
}

export function familyOf(vocab, type) { return vocab?.families?.[type] || "record"; }

export function factsOf(step, limit) {
  const all = (step?.detail || []).filter((d) => !d.identity);
  return limit ? all.slice(0, limit) : all;
}
